import { Pipe, PipeTransform } from '@angular/core';
import { Dictionary } from 'lodash';

@Pipe({
  name: 'localeName',
})
export class LocaleNamePipe implements PipeTransform {
  readonly localeFallback: Dictionary<string> = {
    ae: 'English (South Africa)',
    ar: 'Arabic',
    au: 'English (Australia)',
    b1: 'Portuguese (Brazil] , alt)',
    bg: 'Bulgarian',
    bi: 'Bahasa Indonesian',
    bm: 'Bahasa Malaysia',
    bp: 'Portuguese (Brazil)',
    bs: 'Bosnian',
    ca: 'Castilian Spanish',
    cs: 'Czech',
    cy: 'Welsh',
    da: 'Danish',
    eg: 'English (UK)',
    el: 'Greek',
    em: 'English (Middle East)',
    en: 'English (US)',
    es: 'Spanish',
    et: 'Estonian',
    fc: 'French (Canada)',
    fi: 'Finnish',
    fr: 'French',
    ge: 'English (Greece)',
    gr: 'German',
    hr: 'Croatian',
    hu: 'Hungarian',
    in: 'Indian',
    is: 'Icelandic',
    it: 'Italian',
    ja: 'Japanese',
    ke: 'English (Kenya)',
    ko: 'Korean',
    lt: 'Lithuanian',
    lv: 'Latvian',
    mk: 'Macedonian',
    mt: 'Montenegrin',
    nl: 'Dutch',
    no: 'Norwegian',
    nz: 'English (New Zealand)',
    pl: 'Polish',
    pt: 'Portuguese',
    ro: 'Romanian',
    ru: 'Russian',
    sk: 'Slovak',
    sq: 'Albanian',
    sr: 'Serbian',
    sv: 'Swedish',
    th: 'Thailand',
    tr: 'Turkish',
    vn: 'Vietnamese',
    zc: 'Chinese (Traditional)',
    zh: 'Chinese (Simplified)',
    zk: 'Test',
  };

  transform(value: string, ...args: unknown[]): string {
    try {
      let names = new Intl.DisplayNames([value], { type: 'language' });
      console.log('translating locale ', value, names.of(value), this.localeFallback[value]);
      let intlName = names.of(value);
      if (intlName == value) intlName = this.localeFallback[value];

      return intlName ?? value;
    } catch (error) {
      console.error('Error getting display name for locale: ', error, value);
      return this.localeFallback[value] ?? value;
    }
  }
}
